/* eslint-disable */
import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_API;


const state = {
    guides: []
}

const actions = {
    async retrieveGuides({
        commit,
        dispatch
    }, payload) {
        // retrieve guides list from bus application database        
        return axios
            .get(
                baseUrl + "/excursion/guides/"
            )
            .then(response => {
                commit('SET_GUIDES', response.data)
                return response.data
            })
    },
    async syncGuides({
        commit, dispatch
    }, payload) {
        // force guides sync from ZT to bus application database
        await axios
            .get(
                baseUrl + "/zt/sync_guides/"
            )
            .then(async response => {
                // dispatch retrieve of guides
                await dispatch("retrieveGuides")
            })
    }
}

const mutations = {
    SET_GUIDES(state, guides) {
        state.guides = guides
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}